import React from 'react';
import { FaBrain, FaInfoCircle } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';

const MarketAISummary = ({ macroInsight }) => {
  const summaryRows = [
    { label: 'Contexte', value: macroInsight?.contexte || '—' },
    { label: 'Implication', value: macroInsight?.implication || '—' },
    { label: 'Risque', value: macroInsight?.risque || '—' },
    { label: 'Scénario probable', value: macroInsight?.scenario || '—' },
  ];

  return (
    <div className="market-ai-summary">
      <h3>
        <FaBrain color="#7b2ff2" style={{ marginRight: 8 }} />
        Lecture IA du Marché
        <span data-tooltip-id="ai-tooltip" style={{ marginLeft: 8 }}>
          <FaInfoCircle size={16} color="#aaa" />
        </span>
        <Tooltip id="ai-tooltip" place="top" content="Synthèse générée par l'IA à partir des métriques du marché" />
      </h3>
      <div className="market-ai-summary-grid">
        {summaryRows.map((row) => (
          <div key={row.label} className="market-ai-summary-item">
            <span className="market-ai-summary-label">{row.label}</span>
            <p>{row.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketAISummary;
